module.exports = __webpack_public_path__ + "static/entrance-2.8831db98.png";